import Customer              from "../../../domain/customer/Customer";
import Facility              from "../../../domain/facility/Facility";
import Date                  from "../../../domain/fundamentals/date/Date";
import Time                  from "../../../domain/fundamentals/date/Time";
import TimePeriod            from "../../../domain/fundamentals/date/TimePeriod";
import Plan                  from "../../../domain/plan/Plan";
import Reservation           from "../../../domain/reservation/Reservation";
import ReservationId         from "../../../domain/reservation/ReservationId";
import ReservationRepository from "../../../domain/reservation/ReservationRepository";
import Reservations          from "../../../domain/reservation/Reservations";
import Staff                 from "../../../domain/staff/Staff";
import { ApiClient }         from "../../configure/ApiClientConfig";
import {
  setReservationAction,
  setReservationCustomerAction,
  setReservationDateAction,
  setReservationFacilityAction,
  setReservationStaffAction,
  setReservationTimePeriodAction
}                            from "../../redux/reservation/ReservationAction";
import { setReservationsAction } from "../../redux/reservation/ReservationsAction";

class ReservationDataSource implements ReservationRepository {
  constructor(private readonly dispatch) {
  }

  findBy(date: Date) {
    return ApiClient.get("/reservations", {
      params: {
        date: date.asISOText(),
      }
    });
  }

  register(reservation: Reservation) {
    return ApiClient.post("/reservation", {
      id: reservation.id.value,
      detail: {
        date: reservation.detail.date.asISOText(),
        from: reservation.detail.timePeriod.from.asText(),
        to: reservation.detail.timePeriod.to.asText(),
      },
      customer: {
        id: reservation.customer.id.value,
        detail: {
          number: reservation.customer.detail.number.value,
          last_name: reservation.customer.detail.name.lastName.value,
          first_name: reservation.customer.detail.name.firstName.value,
          last_name_kana: reservation.customer.detail.name.lastNameKana.value,
          first_name_kana: reservation.customer.detail.name.firstNameKana.value,
          gender_type: reservation.customer.detail.genderType,
        },
        birthday: {
          year: reservation.customer.birthday.year.value,
          month: reservation.customer.birthday.month.value,
          date: reservation.customer.birthday.date.value,
        },
        contact: {
          phone_number: reservation.customer.contact.phone.value,
          email: reservation.customer.contact.email.value,
        },
        address: {
          postal_code: reservation.customer.address.postalCode.value,
          prefecture: reservation.customer.address.prefecture.value,
          city: reservation.customer.address.city.value,
          street: reservation.customer.address.street.value,
          building: reservation.customer.address.building.value,
        }
      },
      staff: {
        id: reservation.staff.id.value,
        last_name: reservation.staff.name.lastName.value,
        first_name: reservation.staff.name.firstName.value,
        last_name_kana: reservation.staff.name.lastNameKana.value,
        first_name_kana: reservation.staff.name.firstNameKana.value,
        gender: reservation.staff.genderType,
        memo: reservation.staff.memo.value,
      },
      facility: {
        id: reservation.facility.id.value,
        name: reservation.facility.name.value
      }
    });
  }

  delete(reservationId: ReservationId) {
    return ApiClient.delete("/reservation", {
      params: {
        id: reservationId.value,
      }
    });
  }

  setReservations(reservations: Reservations) {
    this.dispatch(setReservationsAction(reservations));
  }

  setReservation(reservation: Reservation) {
    this.dispatch(setReservationAction(reservation));
  }

  setReservationDate(date: Date) {
    this.dispatch(setReservationDateAction(date));
  }

  setReservationTimePeriod(timePeriod: TimePeriod) {
    this.dispatch(setReservationTimePeriodAction(timePeriod));
  }

  setReservationCustomer(customer: Customer) {
    this.dispatch(setReservationCustomerAction(customer));
  }

  setReservationStaff(staff: Staff) {
    this.dispatch(setReservationStaffAction(staff));
  }

  setReservationFacility(facility: Facility) {
    this.dispatch(setReservationFacilityAction(facility));
  }

  registerPlan(reservation: Reservation, plan: Plan) {
    const from: Time = reservation.detail.timePeriod.from.clone();
    return ApiClient.post("/reservation/plan", {
      id: reservation.id.value,
      detail: {
        date: reservation.detail.date.asISOText(),
        from: reservation.detail.timePeriod.from.asText(),
        to: from.addPlanTimeType(plan.timeType).asText(),
      },
      customer: {
        id: reservation.customer.id.value,
        detail: {
          number: reservation.customer.detail.number.value,
          last_name: reservation.customer.detail.name.lastName.value,
          first_name: reservation.customer.detail.name.firstName.value,
          last_name_kana: reservation.customer.detail.name.lastNameKana.value,
          first_name_kana: reservation.customer.detail.name.firstNameKana.value,
          gender_type: reservation.customer.detail.genderType,
        },
        birthday: {
          year: reservation.customer.birthday.year.value,
          month: reservation.customer.birthday.month.value,
          date: reservation.customer.birthday.date.value,
        },
        contact: {
          phone_number: reservation.customer.contact.phone.value,
          email: reservation.customer.contact.email.value,
        },
        address: {
          postal_code: reservation.customer.address.postalCode.value,
          prefecture: reservation.customer.address.prefecture.value,
          city: reservation.customer.address.city.value,
          street: reservation.customer.address.street.value,
          building: reservation.customer.address.building.value,
        }
      },
      staff: {
        id: reservation.staff.id.value,
        last_name: reservation.staff.name.lastName.value,
        first_name: reservation.staff.name.firstName.value,
        last_name_kana: reservation.staff.name.lastNameKana.value,
        first_name_kana: reservation.staff.name.firstNameKana.value,
        gender: reservation.staff.genderType,
        memo: reservation.staff.memo.value,
      },
      facility: {
        id: reservation.facility.id.value,
        name: reservation.facility.name.value
      },
      plan_id: plan.id.toNumber(),
    });
  }
}

export default ReservationDataSource;
